module.exports = __webpack_public_path__ + "img/question.14943b07.png";